import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import cryptoPayoutFeeGroupsService from "./cryptoPayoutFeeGroupsService";

// GET all fee groups
export const getFeeGroups = createAsyncThunk(
  "admin/cryptoPayoutFeeGroups/list",
  async (_, { rejectWithValue }) => {
    try {
      return await cryptoPayoutFeeGroupsService.getFeeGroups();
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return rejectWithValue(message);
    }
  }
);

// GET simple resellers list
export const getResellersSimple = createAsyncThunk(
  "admin/cryptoPayoutFeeGroups/resellers",
  async (_, { rejectWithValue }) => {
    try {
      return await cryptoPayoutFeeGroupsService.getResellersSimple();
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return rejectWithValue(message);
    }
  }
);

// CREATE fee group
export const createFeeGroup = createAsyncThunk(
  "admin/cryptoPayoutFeeGroups/create",
  async (formData, { rejectWithValue }) => {
    try {
      return await cryptoPayoutFeeGroupsService.createFeeGroup(formData);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return rejectWithValue(message);
    }
  }
);

// UPDATE fee group
export const updateFeeGroup = createAsyncThunk(
  "admin/cryptoPayoutFeeGroups/update",
  async (formData, { rejectWithValue }) => {
    try {
      return await cryptoPayoutFeeGroupsService.updateFeeGroup(formData);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return rejectWithValue(message);
    }
  }
);

// DELETE fee group
export const deleteFeeGroup = createAsyncThunk(
  "admin/cryptoPayoutFeeGroups/delete",
  async (id, { rejectWithValue }) => {
    try {
      return await cryptoPayoutFeeGroupsService.deleteFeeGroup(id);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return rejectWithValue(message);
    }
  }
);

const initialState = {
  feeGroups: [],
  resellers: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",

  isResellersLoading: false,
  isResellersSuccess: false,
  isResellersError: false,

  isCreateSuccess: false,
  isCreateError: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  isDeleteSuccess: false,
  isDeleteError: false,
};

export const cryptoPayoutFeeGroupsSlice = createSlice({
  name: "adminCryptoPayoutFeeGroups",
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isCreateSuccess = false;
      state.isCreateError = false;
      state.isUpdateSuccess = false;
      state.isUpdateError = false;
      state.isDeleteSuccess = false;
      state.isDeleteError = false;
      state.isResellersError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // GET Fee Groups
      .addCase(getFeeGroups.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFeeGroups.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.feeGroups = action.payload;
      })
      .addCase(getFeeGroups.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      // GET Resellers Simple
      .addCase(getResellersSimple.pending, (state) => {
        state.isResellersLoading = true;
      })
      .addCase(getResellersSimple.fulfilled, (state, action) => {
        state.isResellersLoading = false;
        state.isResellersSuccess = true;
        state.resellers = action.payload;
      })
      .addCase(getResellersSimple.rejected, (state, action) => {
        state.isResellersLoading = false;
        state.isResellersError = true;
        state.message = action.payload;
      })

      // CREATE Fee Group
      .addCase(createFeeGroup.fulfilled, (state) => {
        state.isCreateSuccess = true;
      })
      .addCase(createFeeGroup.rejected, (state, action) => {
        state.isCreateError = true;
        state.message = action.payload;
      })

      // UPDATE Fee Group
      .addCase(updateFeeGroup.fulfilled, (state) => {
        state.isUpdateSuccess = true;
      })
      .addCase(updateFeeGroup.rejected, (state, action) => {
        state.isUpdateError = true;
        state.message = action.payload;
      })

      // DELETE Fee Group
      .addCase(deleteFeeGroup.fulfilled, (state) => {
        state.isDeleteSuccess = true;
      })
      .addCase(deleteFeeGroup.rejected, (state, action) => {
        state.isDeleteError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = cryptoPayoutFeeGroupsSlice.actions;
export default cryptoPayoutFeeGroupsSlice.reducer;